<template>
	<li class="party">
		<router-link :to="{ name: 'party', params: { partyId: partyId } }">
			<ProgressBar
				:showPartyInfo="true"
				:partyId="partyId"
				:value="affinity"
				:total="totalStatements"
			>
				{{ affinity }} / {{ totalStatements }}
			</ProgressBar>
		</router-link>
	</li>
</template>

<script>
import ProgressBar from '@/components/UI/ProgressBar'
import { mapState, mapGetters } from 'vuex'

export default {
	props: {
		item: Object
	},

	components: {
		ProgressBar
	},

	computed: {
		...mapGetters(['getAffinityById']),

		...mapState({
			totalStatements: (state) => state.totalStatements
		}),

		partyId() {
			return this.item.partyId
		},

		affinity() {
			return this.getAffinityById(this.partyId)
		}
	}
}
</script>

<style lang="scss" scoped>
.party {
	& + .party {
		margin-top: 10px;
	}
}

a {
	text-decoration: none;
}
</style>
